"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableControlsBar = TableControlsBar;
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _hooks = require("../../common/hooks");
var _position = require("../../common/position");
var _Button = require("../button/Button");
var _IconButton = require("../button/IconButton");
var _ToggleButton = require("../button/ToggleButton");
var _InputGroup = require("../forms/InputGroup");
var _iconNames = require("../icon/iconNames");
var _Frow = require("../layout/Frow");
var _Tooltip = require("../tooltip/Tooltip");
var _ColumnControlDrawer = require("./ColumnControlDrawer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Clear icon used inside search fields
 */
var getClearIcon = function getClearIcon(value, clearHandler) {
  return value.length > 0 ? /*#__PURE__*/React.createElement(_IconButton.IconButton24, {
    icon: _iconNames.IconNames8.CROSS,
    onClick: clearHandler,
    tagName: "span",
    "aria-label": "Clear"
  }) : undefined;
};

/**
 * Debounce hook for the global search
 */
function useDebounce(value, delay) {
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    debounced = _React$useState2[0],
    setDebounced = _React$useState2[1];
  React.useEffect(function () {
    var timer = setTimeout(function () {
      return setDebounced(value);
    }, delay);
    return function () {
      return clearTimeout(timer);
    };
  }, [value, delay]);
  return debounced;
}
function TableControlsBar(_ref) {
  var table = _ref.table,
    renderDrawerExtras = _ref.renderDrawerExtras,
    leftItem = _ref.leftItem,
    _ref$showSearch = _ref.showSearch,
    showSearch = _ref$showSearch === void 0 ? false : _ref$showSearch,
    _ref$showAdvancedSear = _ref.showAdvancedSearch,
    showAdvancedSearch = _ref$showAdvancedSear === void 0 ? false : _ref$showAdvancedSear,
    _ref$showRadiusSearch = _ref.showRadiusSearch,
    showRadiusSearch = _ref$showRadiusSearch === void 0 ? false : _ref$showRadiusSearch,
    _ref$showFiltersButto = _ref.showFiltersButton,
    showFiltersButton = _ref$showFiltersButto === void 0 ? false : _ref$showFiltersButto,
    _ref$showCustomiseBut = _ref.showCustomiseButton,
    showCustomiseButton = _ref$showCustomiseBut === void 0 ? false : _ref$showCustomiseBut,
    _ref$forceDrawerOpen = _ref.forceDrawerOpen,
    forceDrawerOpen = _ref$forceDrawerOpen === void 0 ? false : _ref$forceDrawerOpen;
  var _useVisibility = (0, _hooks.useVisibility)(forceDrawerOpen !== null && forceDrawerOpen !== void 0 ? forceDrawerOpen : false),
    isOpen = _useVisibility.isOpen,
    handleClose = _useVisibility.handleClose,
    toggleOpen = _useVisibility.toggleOpen;
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    globalFilter = _React$useState4[0],
    setGlobalFilter = _React$useState4[1];
  var initialOrderRef = React.useRef([]);
  var initialVisibilityRef = React.useRef({});
  var debouncedFilter = useDebounce(globalFilter, 300);
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isAdvancedSearchOpen = _React$useState6[0],
    setAdvancedSearchOpen = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isRadiusSearchOpen = _React$useState8[0],
    setRadiusSearchOpen = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isFiltersOpen = _React$useState10[0],
    setFiltersOpen = _React$useState10[1];

  /**
   * Column state initialisation
   */
  var initColumnState = React.useCallback(function () {
    var initialOrder = table.getAllLeafColumns().map(function (c) {
      return c.id;
    });
    var initialVisibility = {};
    table.getAllLeafColumns().forEach(function (column) {
      if (column.getCanHide()) {
        initialVisibility[column.id] = column.getIsVisible();
      } else {
        initialVisibility[column.id] = true;
      }
    });
    initialOrderRef.current = initialOrder;
    initialVisibilityRef.current = initialVisibility;
  }, [table]);

  /**
   * Run once on mount to initialise refs
   */
  var hasInitialisedColumnStateRef = React.useRef(false);
  React.useEffect(function () {
    if (!hasInitialisedColumnStateRef.current) {
      initColumnState();
      hasInitialisedColumnStateRef.current = true;
    }
  }, [initColumnState]);

  /**
   * Restore temp visibility when drawer opens
   */
  React.useEffect(function () {
    if (isOpen) {
      var drawerColumnsVisibility = {};
      table.getAllLeafColumns().forEach(function (col) {
        drawerColumnsVisibility[col.id] = col.getIsVisible();
      });
    }
  }, [isOpen, table]);

  /**
   * Global filter search
   */
  React.useEffect(function () {
    table.setGlobalFilter(debouncedFilter);
  }, [debouncedFilter, table]);

  /**
   * Clear icon handlers for search bars
   */
  var handleClearGlobal = function handleClearGlobal() {
    return setGlobalFilter('');
  };
  var globalClearIcon = getClearIcon(globalFilter, handleClearGlobal);

  /**
   * Toggle button handlers
   */
  var toggleAdvancedSearch = function toggleAdvancedSearch() {
    setAdvancedSearchOpen(function (prev) {
      return !prev;
    });
    setRadiusSearchOpen(false);
    setFiltersOpen(false);
  };
  var toggleRadiusSearch = function toggleRadiusSearch() {
    setRadiusSearchOpen(function (prev) {
      return !prev;
    });
    setAdvancedSearchOpen(false);
    setFiltersOpen(false);
  };
  var toggleFilters = function toggleFilters() {
    setFiltersOpen(function (prev) {
      return !prev;
    });
    setAdvancedSearchOpen(false);
    setRadiusSearchOpen(false);
  };
  return /*#__PURE__*/React.createElement(_Frow.Frow, {
    justifyContent: "space-between",
    alignItems: "center",
    className: _classes.Classes.TABLE_CONTROLS_BAR
  }, /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_LEFT
  }, leftItem, showSearch && /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_SEARCH_WRAPPER
  }, /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_INPUT_CONTAINER
  }, /*#__PURE__*/React.createElement(_InputGroup.InputGroup, {
    placeholder: "Search",
    leftIcon: _iconNames.IconNames16.MAGNIFYING_GLASS,
    rightElement: globalClearIcon,
    large: true,
    style: {
      width: '100%'
    },
    value: globalFilter,
    onChange: function onChange(e) {
      return setGlobalFilter(e.target.value);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.TABLE_CONTROLS_RIGHT
  }, showAdvancedSearch && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Advanced search",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_ToggleButton.ToggleButton, {
    text: "ADVANCED",
    toggled: isAdvancedSearchOpen,
    onClick: toggleAdvancedSearch,
    buttonStyle: "tertiary",
    large: true,
    icon: _iconNames.IconNames16.MAGNIFYING_GLASS
  })), showRadiusSearch && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Radius search",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_ToggleButton.ToggleButton, {
    text: "RADIUS",
    toggled: isRadiusSearchOpen,
    onClick: toggleRadiusSearch,
    buttonStyle: "tertiary",
    large: true,
    icon: _iconNames.IconNames16.CROSSHAIR
  })), showFiltersButton && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Filter Table",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_ToggleButton.ToggleButton, {
    text: "FILTERS",
    toggled: isFiltersOpen,
    onClick: toggleFilters,
    buttonStyle: "tertiary",
    large: true,
    icon: _iconNames.IconNames16.FILTER
  })), showCustomiseButton && /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: "Customise columns",
    position: _position.Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(_Button.Button, {
    text: "CUSTOMISE",
    buttonStyle: "tertiary",
    onClick: toggleOpen,
    large: true,
    icon: _iconNames.IconNames16.COLUMNS_3,
    "aria-expanded": isOpen,
    "aria-controls": "customise-columns-heading"
  }))), /*#__PURE__*/React.createElement(_ColumnControlDrawer.ColumnControlDrawer, {
    table: table,
    renderDrawerExtras: renderDrawerExtras,
    isOpen: isOpen,
    handleClose: handleClose
  }));
}